/* © CNES */
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import './DataBadge.scss';

/**
 * Display Data Badge in app header and trigger dialog on click.
 * @returns DataBadge Element.
 */
export const DataBadge = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Badge
        aria-label="data-badge"
        id="data-badge"
        severity="danger"
        onClick={() => setVisible(true)}
      />
      <Dialog
        aria-label="dialog-badge"
        visible={visible}
        modal={false}
        className="dialogData"
        onHide={() => setVisible(false)}
        onClick={() => setVisible(false)}
        showHeader={false}
      >
        <p>test</p>
      </Dialog>
    </>
  );
};
